import { Caption1, DrawerBody, DrawerHeader, OverlayDrawer, makeStyles, tokens } from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import type { ReactNode } from "react";
import { FuiButton } from "@/components/fui-control";

const useStyles = makeStyles({
  drawer: {
    width: "520px",
    maxWidth: "100vw",
  },
  backdrop: {
    backdropFilter: "blur(2.5px)",
    WebkitBackdropFilter: "blur(2.5px)",
    backgroundColor: "rgba(0, 0, 0, 0.16)",
  },
  header: {
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalL}`,
  },
  headerTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "32px",
    width: "100%",
  },
  title: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: tokens.colorNeutralForeground3,
  },
  body: {
    padding: "16px",
    overflowY: "auto",
  },
});

/** 지금 화면을 읽는 패널. 오른쪽에서 열리고, 입력과 저장은 없다. */
export function ScreenHelpDrawer({ open, title, onClose, children }: { open: boolean; title: string; onClose: () => void; children: ReactNode }) {
  const styles = useStyles();
  return (
    <OverlayDrawer
      open={open}
      position="end"
      modalType="modal"
      className={styles.drawer}
      backdrop={{ className: styles.backdrop }}
      onOpenChange={(_, data) => {
        if (!data.open) onClose();
      }}
      aria-label={title}
    >
      <DrawerHeader className={styles.header}>
        <div className={styles.headerTop}>
          <Caption1 className={styles.title}>{title}</Caption1>
          <FuiButton appearance="subtle" icon={<Dismiss24Regular />} aria-label="닫기" onClick={onClose} />
        </div>
      </DrawerHeader>
      <DrawerBody className={styles.body}>{children}</DrawerBody>
    </OverlayDrawer>
  );
}
